export interface BirthCertificate {
  appName: string;
  json?: string;
  pdfBuffer?: string;
  html?: string;
  success: boolean;
  responseType: BirthCertificateResponseType;
}

export enum BirthCertificateResponseType {
  Pdf = 'Pdf',
  Json = 'Json',
  Html = 'Html',
}

export interface GeneratePBOMInput {
  appId: string;
  responseType: BirthCertificateResponseType;
}

export interface FetchReadyPBOMInput {
  requestId: string;
}

// TODO: remove once we stop supporting legacy pdf service
export interface GenerateBirthCertificateInput {
  appId: string;
  responseType: BirthCertificateResponseType;
}
